import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 摄像头在线状态
 */
class CameraStatus extends UltMeta {
    OFFLINE = new Meta(0, "离线");
    ONLINE = new Meta(1, "在线");
}

export const CAMERA_STATUS = new CameraStatus();

// 设备 类型
class CameraType extends UltMeta {
    CAMERA = new Meta(1, "摄像头"); // IPC
    VIDEO = new Meta(2, "硬盘录像机"); // NVR
}

export const CAMERA_TYPE = new CameraType();
